
import service from "../api/services/centerAndBatchesService";



export default {
  namespaced: true,
  state: {
   
  },
  
  mutations: {
    
  },
  actions: {
   
    getCenters(context,reqData) {
      return service.getCenters(reqData).then((response = {}) => {   
      
        return response.responseData;
      }).catch((error)=>{         
        return Promise.reject(error);
      });
    },
    getCentersByUser(context,reqData) {
      return service.getCentersByUser(reqData).then((response = {}) => {   
      
        return response.responseData;
      }).catch((error)=>{         
        return Promise.reject(error);
      });
    },
    getBatches(context,reqData) {
      return service.getBatches(reqData).then((response = {}) => {         
        return response.responseData;
      }).catch((error)=>{         
        return Promise.reject(error);
      });
    }, 
    getBatchForScheduleTest(context,reqData) {
      return service.getBatchForScheduleTest(reqData).then((response = {}) => {         
        return response.responseData;
      }).catch((error)=>{         
        return Promise.reject(error);
      });
    },     
    upsertCenter(context,reqData) {
      return service.upsertCenter(reqData).then((response = {}) => {         
        return response.responseData;
      }).catch((error)=>{         
        return Promise.reject(error);
      });
    }, 
    upsertBatch(context,reqData) {
      return service.upsertBatch(reqData).then((response = {}) => {         
        return response.responseData;
      }).catch((error)=>{         
        return Promise.reject(error);
      });
    }, 
    deleteBatch(context,reqData) {
      return service.deleteBatch(reqData).then((response = {}) => {         
        return response.responseData;
      }).catch((error)=>{         
        return Promise.reject(error);
      });
    }, 
    deleteCenter(context,reqData) {
      return service.deleteCenter(reqData).then((response = {}) => {         
        return response.responseData;
      }).catch((error)=>{         
        return Promise.reject(error);
      });
    }, 
    getBatchStudentsSubjectTree(context,reqData) {
      return service.getBatchStudentsSubjectTree(reqData).then((response = {}) => {         
        return response.responseData;
      }).catch((error)=>{         
        return Promise.reject(error);
      });
    }, 
    getCenterBatchesBySchedule(context,reqData) {
      return service.getCenterBatchesBySchedule(reqData).then((response = {}) => {   
        return response.responseData;
      }).catch((error)=>{         
        return Promise.reject(error);
      });
    },
  }
};
